<script setup lang="ts">
const { trackEvent } = useGAnalytics();
const userStore = useUserStore();
</script>

<template>
  <HeadlessPopover
    v-slot="{ open, close }"
    class="text-neutral-200 flex items-center">
    <HeadlessPopoverButton
      class="focus:outline-hidden"
      data-test="button-menu-header-profile">
      <div
        class="hidden md:flex cursor-pointer h-min items-center gap-1"
        @click="trackEvent('header_profile')">
        <div class="flex items-center gap-2">
          <CommonUserProfilePicture
            :profile-picture="userStore.profilePicture"
            size="custom"
            custom-class="w-12 h-12 shadow-xs shadow-black" />
          <p
            v-if="!userStore.isLoggedIn"
            class="text-neutral-200 font-semibold text-sm">
            {{ $t("main.headerComponent.account") }}
          </p>
        </div>
        <NuxtIcon
          name="mdi:keyboard-arrow-down"
          class="-mr-1 w-6 h-6 transition-all duration-300 text-neutral-300"
          :class="{ 'rotate-180': open }" />
      </div>
      <NuxtIcon
        v-if="open"
        name="mdi:close"
        :alt="$t('main.imageAltTexts.closeIcon')"
        class="md:hidden w-9 h-9 text-neutral-300 cursor-pointer" />
      <div v-else class="flex items-end">
        <span
          v-if="userStore.notifications.unread > 0"
          class="md:hidden absolute top-0 right-0 w-2 h-2 bg-primary-500 rounded-full"></span>
        <NuxtIcon
          name="mdi:user-outline"
          class="md:hidden w-9 h-9 text-neutral-300" />
      </div>
    </HeadlessPopoverButton>
    <transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="transform opacity-0 translate-x-full md:translate-x-0 md:scale-95"
      enter-to-class="transform opacity-100 translate-x-0 md:scale-100"
      leave-active-class="transition ease-in duration-200"
      leave-from-class="transform opacity-100 translate-x-0 md:scale-100"
      leave-to-class="transform opacity-0 translate-x-full md:translate-x-0 md:scale-95">
      <HeadlessPopoverPanel
        class="height fixed bg-neutral-800 z-30 shadow-sm shadow-black top-[95px] -right-0 w-screen custom-min-height max-h-dvh md:absolute md:mt-0 md:top-14 md:-right-1 md:rounded-xl md:min-h-fit md:w-80 grid grid-rows-[73px_1fr_80px] overflow-y-hidden md:grid-rows-none">
        <HeaderAccountUserMenuDropdown :close="close" />
      </HeadlessPopoverPanel>
    </transition>
  </HeadlessPopover>
</template>

<style scoped>
@media (max-width: 767px) {
  .custom-min-height {
    min-height: calc(100dvh - 104px);
  }
}

.height {
  height: -moz-fit-content;
}
</style>
